import { Amplify } from "aws-amplify";
import { record } from 'aws-amplify/analytics';
import amplifyconfig from './amplifyconfiguration.json';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { DataStore } from 'aws-amplify/datastore';
import { Todo } from './models';
import PlayPage from './PlayPage';
import SongMetadataEditor, { SongDataProvider, useUpdateSongData } from './SongMetadataEditor';
import SongSaveEditor, { SongSaveDataProvider, useUpdateSongSaveData } from './SongSaveEditor';

import { signInWithRedirect } from "aws-amplify/auth"

Amplify.configure(amplifyconfig);



/*
await DataStore.save(
  new Todo({
  "name": "Task 1",
  "description": "Lorem ipsum dolor sit amet"
})
);

const models = await DataStore.query(Todo);
console.log(models);
*/
//signInWithRedirect({ provider: "Google" })
/*
const setGlobalUpdateFunction = useUpdateSongData();

useEffect(() => {
  // Expose the update function to the global scope
  window.updateSongData = setGlobalUpdateFunction;
  return () => {
    delete window.updateSongData; // Cleanup on unmount
  };
}, [setGlobalUpdateFunction]);
*/
const root = ReactDOM.createRoot(document.getElementById('root'));



const songData0 = {
  tags: {
    g: ["rock", "pop"], // Example tag IDs for genre
    y: ["1980s", "2000s"], // Example tag IDs for years
    o: ["party", "romantic"], // Example tag IDs for other
    l: ["New York", "London"] // Example tag IDs for locations
  },
  artists: [
    {
      id: "artist1",
      name: "Artist One",
      tags: {
        b: ["band"], // Example tag IDs for band info
        o: ["legendary"], // Example tag IDs for other
        c: ["USA"], // Example tag IDs for country
        s: ["solo"] // Example tag IDs for style
      }
    },
    {
      id: "artist2",
      name: "Artist Two",
      tags: {
        b: ["duo"],
        o: ["innovative"],
        c: ["UK"],
        s: ["collaboration"]
      }
    }
  ],
  names: {
    rock: "Rock",
    pop: "Pop",
    "1980s": "1980s",
    "2000s": "2000s",
    party: "Party",
    romantic: "Romantic",
    "New York": "New York",
    London: "London",
    band: "Band",
    legendary: "Legendary",
    USA: "USA",
    solo: "Solo",
    duo: "Duo",
    innovative: "Innovative",
    UK: "UK",
    collaboration: "Collaboration"
  },
  categories: {
    g: "Genres",
    y: "Years",
    o: "Other",
    l: "Locations",
    b: "Band Info",
    c: "Country",
    s: "Style"
  }
};

const songSaveData0 = {
  tags: {
    t: ["1"] // Example tag IDs for song tags,
  },
  categories: {
    t: "Tags",
  },
  options: {
    t: { 
    "0": "Audio",
    "1": "Video",     
    "2": "Explicit Lyrics",
    "3": "Explicit Video", 
    "4": "Live",
    "5": "Dance Video",
    "6": "Instrumental",
    "7": "Cover",
    }
  }
};

//console.log("just before root.render");

root.render(
  <React.StrictMode>   
    <SongDataProvider initialData={songData0}>
      <SongSaveDataProvider initialData={songSaveData0}>
        <PlayPage />
      </SongSaveDataProvider>
    </SongDataProvider> 
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

